module.exports = __webpack_public_path__ + "assets/learnkey-logo-cr-en.ea1eaf98.svg";